const CharacterStates = {
  Neutral: 'Neutral',
  TryAgain: 'Try Again',
  Incorrect: 'Incorrect',
  Correct: 'Correct',
};

const Correctness = {
  Correct: 'correct',
  Incorrect: 'incorrect',
};

const ResourceTypes = {
  Answer: 'Answer',
};

const Tooltips = {
  Quiz: {
    CATAMultiSelect: `Click a choice box below to select it. Once you've selected every correct answer, click Submit.`,
    CATAMultiSelectEdits_Vertical: `Click a choice box below to select it. To view a choice's edits in the document, select that choice or hover on the choice and click the view button. Once you've selected every correct answer, click Submit.`,
    CATAMultiSelectEdits_Horizontal: `Click a choice box below to select it. To view a choice's edits in the document, select that choice or hover on the choice and click the view button. Once you've selected every correct answer, click Submit.`,
    CATASingleSelect: `Click a choice box below to select it. Once you've selected the best answer, click Submit.`,
    CATASingleSelectEdits_Vertical: `Click a choice box below to select it. To view a choice's edits in the document, select that choice or hover on the choice and click the view button. Once you've selected the best answer, click Submit.`,
    CATASingleSelectEdits_Horizontal: `Click a choice box below to select it. To view a choice's edits in the document, select that choice or hover on the choice and click the view button. Once you've selected the best answer, click Submit.`,
    CBS: `Click any text character within the correct region in the text below. Then click Submit.`,
    CBSParagraphSingle: `The outlined regions of the text below are your choices. Click the correct one, and then click Submit.`,
    CBSParagraphMulti: `The outlined regions of the text below are your choices. Click all the correct choices, and then click Submit.`,
  },
  Feedback: {
    CATAMultiSelect: `Click the "?" button to see/hide the explanation for each choice. We've auto-expanded the explanation for any choice where you made a mistake.`,
    CATAMultiSelectEdits_Vertical: `Click the "?" button to see/hide the explanation for each choice. We've auto-expanded the explanation for any choice where you made a mistake.`,
    CATAMultiSelectEdits_Horizontal: `Click the "?" button to see the explanation for each choice.`,
    CATASingleSelect: `Click the "?" button to see/hide the explanation for each choice. We've auto-expanded the explanation for any choice where you made a mistake.`,
    CATASingleSelectEdits_Vertical: `Click the "?" button to see/hide the explanation for each choice. We've auto-expanded the explanation for any choice where you made a mistake.`,
    CATASingleSelectEdits_Horizontal: `Click the "?" button to see the explanation for each choice.`,
    CBS: ``,
    CBSParagraphSingle: ``,
    CBSParagraphMulti: ``,
  },
};

const Instructions = {
  Quiz: {
    CATAMultiSelect: `Choose all the correct answers`,
    CATAMultiSelectEdits_Vertical: `Choose all the correct answers`,
    CATAMultiSelectEdits_Horizontal: `Choose all the correct answers`,
    CATASingleSelect: `Choose the best answer`,
    CATASingleSelectEdits_Vertical: `Choose the best answer`,
    CATASingleSelectEdits_Horizontal: `Choose the best answer`,
    CBS: `Click the correct location`,
    CBSParagraphSingle: `Click the correct part of the text`,
    CBSParagraphMulti: `Click the correct parts of the text`,
  },
  Feedback: {
    CATAMultiSelect: `Review the explanations`,
    CATAMultiSelectEdits_Vertical: `Review the explanations`,
    CATAMultiSelectEdits_Horizontal: `Review the explanations`,
    CATASingleSelect: `Review the explanations`,
    CATASingleSelectEdits_Horizontal: `Review the explanations`,
    CATASingleSelectEdits_Vertical: `Review the explanations`,
    CBS: `Review the explanation`,
    CBSParagraphSingle: `Review the explanations`,
    CBSParagraphMulti: `Review the explanations`,
  },
};

const Lorem = {
  Short: [
    `Lorem ipsum odor amet, consectetuer adipiscing elit. Sodales quam accumsan litora hac sem nisi mus tincidunt. Nulla eu a rhoncus nulla ullamcorper class; est praesent fames. Penatibus natoque mattis id nunc non metus.`,
  ],
  Shorter: [
    `Lorem ipsum odor amet, consectetuer adipiscing elit. Sodales quam accumsan litora hac sem nisi mus tincidunt. Nulla eu a rhoncus nulla ullamcorper class;`,
  ],
  Long: [
    `Lorem ipsum odor amet, consectetuer adipiscing elit. Eu mollis porttitor conubia id lobortis sodales. Mus venenatis mus urna vitae consequat vel litora etiam. Dolor rutrum donec imperdiet; lectus turpis convallis mauris. Condimentum ultricies potenti commodo maximus ultrices nibh venenatis purus. Orci risus tempus elementum cursus at varius justo.`,
    `Metus aliquet habitasse tempus vestibulum adipiscing vivamus nisl. Maecenas erat lobortis orci nisi torquent sodales massa. Lectus sem posuere eros iaculis condimentum primis purus. Quam aenean sociosqu eu nunc iaculis.`,
    `Tempor quisque odio magnis bibendum tempus scelerisque. Tincidunt vivamus nunc arcu hac facilisi aptent quisque bibendum venenatis. Montes ad luctus quisque vehicula tempus est. Justo neque penatibus feugiat diam penatibus nam maecenas laoreet. Hendrerit sed in gravida ornare pellentesque libero.`,
    `Ornare tempus nisi parturient pellentesque class efficitur. Lacinia suscipit hac tellus ultrices rhoncus ante. Vivamus natoque duis vitae imperdiet inceptos efficitur gravida eleifend viverra. Dui fringilla efficitur ultrices aptent felis auctor.`,
    `Dignissim mi turpis consequat nostra sociosqu ante. Justo eget diam curae sem ante quis, libero congue aliquet. Efficitur est tortor cras nascetur tellus vitae platea. Molestie sodales nam sodales facilisis quam viverra urna nibh. Eleifend taciti urna diam hac ut neque pretium elementum. Ad quam taciti nisi taciti per tincidunt accumsan.`,
    `Fermentum leo ultrices dictumst tortor quisque iaculis vestibulum. Proin finibus tortor finibus proin malesuada vel. Hendrerit phasellus penatibus class platea netus augue. Pellentesque sem dolor torquent euismod pharetra aenean. Fringilla iaculis fames varius velit consectetur aptent lacus. Litora aliquam gravida lectus quam venenatis facilisi urna. Tempor sociosqu egestas facilisis mus bibendum tellus suscipit integer.`,
    `Lacinia sodales dui; nec est imperdiet rhoncus porta class. Potenti convallis inceptos ultricies cras dapibus. Arcu cras porttitor, penatibus torquent euismod sociosqu pulvinar eros. Montes class viverra aliquet phasellus potenti potenti justo maximus. Hendrerit molestie iaculis viverra ante tempus quisque tincidunt. Sed diam potenti aptent class mattis.`,
    `Sed venenatis risus ante vitae faucibus. Ex efficitur egestas a tempus porta amet condimentum. Proin potenti dignissim netus mattis integer quis. Aenean congue justo senectus duis congue eros potenti odio. Per efficitur viverra lorem quisque a nec. Ex leo quam tristique lectus blandit dapibus ridiculus tempus.`,
  ],
};

const LoremLengths = {
  Short: 'short',
  Long: 'long',
  None: 'none',
};

// MessageTypes is the shared iframe-bridge contract from @praktio/common-ui — re-exported below.

const AnnotationOffscreenPositions = {
  Top: 'TOP',
  Bottom: 'BOTTOM',
  Left: 'LEFT',
  Right: 'RIGHT',
};

// Classes emitted on characters rendered from an Answer's own edits (CATA edit slides),
// in addition to the subtype class. Consumed by the custom stylesheet, not by app CSS.
export const EDIT_ANNOTATION_CLASS = 'is-edit';
export const EDIT_ANNOTATION_CLASS_PREFIX = 'edit-';

export enum CATALayouts {
  RIGHT_HEAVY = 'Right Heavy',
  TRI_PANEL = 'Tri-panel',
}

// If changing breakpoint sizes here, be sure to also
// change them in variables.scss.
export enum BreakpointSizes {
  MediumBreakpoint = 880,
  LargeBreakpoint = 1268,
}

export enum WindowSizes {
  Small = 'window-small',
  Medium = 'window-medium',
  Large = 'window-large',
}

export enum SupplementalDocStates {
  Closed = 'closed',
  HalfOpen = 'half-open',
  FullyOpen = 'fully-open',
}

export enum ImageDisplayMode {
  Inherit = 'inherit', // Use the resource panel's display mode
  Contain = 'contain', // Current behavior - fit entire image, may leave whitespace
  Cover = 'cover', // Fill container, crop if needed
  Fill = 'fill', // Stretch to fill (may distort)
}

export {
  CharacterStates,
  ResourceTypes,
  Tooltips,
  Instructions,
  Correctness,
  Lorem,
  LoremLengths,
  AnnotationOffscreenPositions,
};

export { MessageTypes } from '@praktio/common-ui';

// Must match the class praktio-author derives at read time ('pa-' + className) for the
// author-defined Styles-tab style whose className is "material-icons". Slides store only that
// style's styleId, so find usages by the style's _id, not by this string. Text with this class
// renders through the Material Icons font ligature, so its characters must not receive the
// screen reader special characters. If that style is renamed, icons break again without any error.
export const MATERIAL_ICON_CLASS = 'pa-material-icons';
